<div class="pvl-shell" (click)="fecharDropdown(); fecharMenuEngrenagem()">
  <div class="container">

    <!-- ── PAGE HEADER ── -->
    <div class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>Pedidos de Venda</h1>
        <p>Consulte e acompanhe os pedidos gerados</p>
      </div>
      <button type="button" class="btn-imprimir"
              [disabled]="pedidoSelecionado == null"
              (click)="onImprimir()"
              [title]="pedidoSelecionado == null ? 'Selecione um pedido para imprimir' : 'Imprimir pedido #' + pedidoSelecionado">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 6 2 18 2 18 9"/>
          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
          <rect x="6" y="14" width="12" height="8"/>
        </svg>
        Imprimir{{ pedidoSelecionado != null ? ' #' + pedidoSelecionado : '' }}
      </button>
      <button type="button" class="btn-novo" (click)="novoPedido.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        Novo Pedido
      </button>
      <div class="dropdown-wrapper">
        <button type="button" class="btn-engrenagem"
                [class.btn-engrenagem-ativo]="menuEngrenagemAberto"
                (click)="toggleMenuEngrenagem($event)"
                title="Ações">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </button>
        <div class="dropdown-menu" *ngIf="menuEngrenagemAberto" (click)="$event.stopPropagation()">
          <button class="dropdown-item" (click)="onGerarVendaOS($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="12" y2="18"/><line x1="15" y1="15" x2="12" y2="18"/>
            </svg>
            Gerar Venda a Partir da O.S
          </button>
          <div class="dropdown-divider"></div>
          <button class="dropdown-item" (click)="onGerarVendaLegado($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
              <line x1="12" y1="22.08" x2="12" y2="12"/>
            </svg>
            Gerar Venda a Partir de Sistema Legado
          </button>
        </div>
      </div>
    </div>

    <!-- ── BADGE: Filtro de fluxo ativo ── -->
    <div class="filtro-fluxo-badge" *ngIf="filtroFluxoNunotas">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/>
        <path d="M6 9v6"/><path d="M9 6h7a2 2 0 0 1 2 2v7"/>
      </svg>
      <span>
        Exibindo apenas os <strong>{{ filtroFluxoNunotas.size }} pedidos</strong> do {{ filtroFluxoLabel }}
      </span>
      <button type="button" class="filtro-fluxo-limpar" (click)="limparFiltroFluxo()" title="Remover filtro de fluxo">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
        Limpar filtro
      </button>
    </div>

    <!-- ── FILTROS ── -->
    <div class="filtros-bar">

      <!-- Busca rápida — cliente/CNPJ/vendedor -->
      <div class="filtro-busca-rapida filtro-busca-rapida--destaque">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Filtrar por cliente, CNPJ, vendedor, prefixo ou Nº do pedido..."
               [(ngModel)]="termoBusca"
               (ngModelChange)="onTermoBuscaChange()">
        <button *ngIf="termoBusca" type="button" class="busca-limpar" (click)="termoBusca=''; onTermoBuscaChange()">✕</button>
      </div>
      <div *ngIf="buscandoPorNunota" class="busca-nunota-status">Buscando pedido #{{ termoBusca }}...</div>
      <div *ngIf="nunotaNaoEncontrado" class="busca-nunota-status busca-nunota-erro">Pedido #{{ nunotaNaoEncontrado }} não encontrado.</div>

      <!-- Busca por PN / Descrição -->
      <div class="filtro-busca-rapida filtro-busca-pn">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        </svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Buscar por PN ou descrição..."
               [(ngModel)]="termoBuscaPn"
               (ngModelChange)="onTermoBuscaPnChange()">
        <button *ngIf="termoBuscaPn" type="button" class="busca-limpar"
                (click)="termoBuscaPn=''; buscar()">✕</button>
      </div>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <div class="filtro-grupo">
        <label>De</label>
        <input type="date" class="input-data" [(ngModel)]="dtDe">
      </div>
      <div class="filtro-grupo">
        <label>Até</label>
        <input type="date" class="input-data" [(ngModel)]="dtAte">
      </div>
      <button type="button" class="btn-buscar" (click)="buscar()" [disabled]="carregando"><app-loading-indicator *ngIf="carregando" size="inline"></app-loading-indicator>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        {{ carregando ? 'Buscando...' : 'Buscar' }}
      </button>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <!-- Checkbox cancelados -->
      <label class="filtro-toggle" (click)="$event.stopPropagation()">
        <input type="checkbox" [(ngModel)]="mostrarCancelados" (ngModelChange)="onMostrarCanceladosChange()">
        <span class="toggle-label">Exibir cancelados</span>
      </label>
    </div>

    <!-- ── ERRO/NOTIFICAÇÃO ── -->
    <div *ngIf="erro" class="alerta alerta-erro">{{ erro }}</div>
    <div *ngIf="erroCancelamento" class="alerta alerta-erro">{{ erroCancelamento }}</div>

    <!-- ── TABELA ── -->
    <div class="tabela-card">
      <div *ngIf="carregando" class="loading-row">
        <app-loading-indicator></app-loading-indicator>
        <span>Carregando pedidos...</span>
      </div>

      <div *ngIf="!carregando && pedidos.length === 0 && !erro" class="vazio-row">
        Nenhum pedido encontrado no período selecionado.
      </div>

      <div *ngIf="!carregando && pedidos.length > 0 && pedidosFiltrados.length === 0" class="vazio-row">
        Nenhum pedido corresponde ao filtro "{{ termoBusca }}".
      </div>

      <ng-container *ngIf="!carregando && pedidosFiltrados.length > 0">
        <table class="tabela">
          <thead>
            <tr>
              <th>Nº da Venda</th>
              <th class="col-center">Nº Título</th>
              <th>Data</th>
              <!-- STATUSNOTA (status nativo do Sankhya) ocultado por ora — fica
                   confuso ter duas colunas "Status" ao lado do GPL_STATUS. -->
              <th class="col-center" *ngIf="false">Status</th>
              <th>CNPJ</th>
              <th>Cliente</th>
              <th>Vendedor</th>
              <th class="col-right">Valor R$</th>
              <th class="col-right">Valor U$</th>
              <th>Tipo Oper.</th>
              <th class="col-center">Status</th>
              <th>Prefixo</th>
              <th>Observação Nota</th>
              <th class="col-center col-acoes-th">Ações</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let p of pedidosPagina">
              <tr (click)="selecionarLinha($event, p.nunota)"
                  (dblclick)="onDblClickLinha(p)"
                  (contextmenu)="abrirMenuAcoesContexto($event, p)"
                  class="linha-clicavel"
                  [class.linha-cancelada]="ehCancelado(p)"
                  [class.linha-selecionada]="pedidoSelecionado === p.nunota"
                  [title]="podeEditar(p) ? 'Clique para selecionar · Duplo clique para editar' : 'Clique para selecionar · Duplo clique para visualizar'">
                <td class="col-nunota" [class.nunota-com-fluxo]="p.temFluxo">{{ p.nunota }}</td>
                <td class="col-center">{{ p.numTitulo || '—' }}</td>
                <td class="col-data">{{ p.dtmov }}</td>
                <!-- STATUSNOTA (status nativo do Sankhya) ocultado por ora — ver th correspondente acima. -->
                <td class="col-center" *ngIf="false">
                  <span class="status-badge" [ngClass]="statusClass(p.status)">{{ p.status }}</span>
                </td>
                <td class="col-cnpj">{{ fmtDocumento(p.docparc) }}</td>
                <td class="col-cliente">{{ p.cliente }}</td>
                <td class="col-vend">{{ p.vendedor }}</td>
                <td class="col-right col-valor">{{ fmtBrl(vlrTotal(p)) }}</td>
                <td class="col-right col-valor">{{ fmtUsd(vlrTotalUsd(p)) }}</td>
                <td class="col-tipo">
                  <span class="tipo-doc-badge"
                        [class.badge-orcamento]="ehOrcamento(p)"
                        [class.badge-pedido]="!ehOrcamento(p)"
                        [title]="p.tipoOperacao">
                    {{ ehOrcamento(p) ? 'Orçamento' : 'Pedido' }}
                  </span>
                </td>
                <td class="col-center col-gpl-status">
                  <span *ngIf="p.gplStatus === 'ABERTO'" class="gpl-status-badge gpl-aberto">Aberto</span>
                  <span *ngIf="p.gplStatus === 'AUTORIZADO'" class="gpl-status-badge gpl-autorizado">Autorizado</span>
                  <span *ngIf="p.gplStatus === 'PENDENTE'" class="gpl-status-badge gpl-aguardando">Pendente</span>
                  <span *ngIf="p.gplStatus === 'SEPARACAO'" class="gpl-status-badge gpl-separacao">Separação</span>
                  <span *ngIf="p.gplStatus === 'SEPARACAO TOTAL'" class="gpl-status-badge gpl-sep-total">Separação Total</span>
                  <span *ngIf="p.gplStatus === 'CONFERENCIA'" class="gpl-status-badge gpl-conferencia">Conferência</span>
                  <span *ngIf="p.gplStatus === 'PENDENCIA VENDEDOR'" class="gpl-status-badge gpl-pendencia-vendedor" title="Divergência encontrada na Conferência — aguardando o vendedor resolver">Pendência Vendedor</span>
                  <span *ngIf="p.gplStatus === 'LOGISTICA'" class="gpl-status-badge gpl-logistica">Logística</span>
                  <span *ngIf="p.gplStatus === 'PRONTO'" class="gpl-status-badge gpl-pronto">Pronto</span>
                  <span *ngIf="p.gplStatus === 'FINALIZADO'" class="gpl-status-badge gpl-finalizado">Finalizado</span>
                  <span *ngIf="p.gplStatus === 'CANCELADO'" class="gpl-status-badge gpl-cancelado">Cancelado</span>
                  <span *ngIf="p.gplStatus === 'REPROVADO'" class="gpl-status-badge gpl-reprovado" title="Liberação de desconto/estoque reprovada pelo gestor">Reprovado</span>
                </td>
                <td class="col-aero">{{ p.aeronave || '—' }}</td>
                <td class="col-obs">
                  <span class="obs-texto" [title]="p.observacao || ''">{{ p.observacao || '—' }}</span>
                </td>
              <td class="col-center col-acoes" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                <div class="dropdown-wrapper" *ngIf="!ehCancelado(p)">
                  <button class="btn-dots"
                    [class.btn-dots-ativo]="dropdownAberto === p.nunota"
                    (click)="toggleDropdown($event, p)"
                    [disabled]="cancelando === p.nunota"
                    title="Ações">
                    <span *ngIf="cancelando !== p.nunota">⋮</span>
                    <app-loading-indicator *ngIf="cancelando === p.nunota" size="inline"></app-loading-indicator>
                  </button>
                  <div class="dropdown-menu"
                    [class.dropdown-menu-cima]="dropdownAbrirParaCima && !dropdownPosFixa"
                    [class.dropdown-menu-fixo]="!!dropdownPosFixa"
                    [style.top.px]="dropdownPosFixa ? dropdownPosFixa.top : null"
                    [style.left.px]="dropdownPosFixa ? dropdownPosFixa.left : null"
                    [style.right]="dropdownPosFixa ? 'auto' : null"
                    [style.bottom]="dropdownPosFixa ? 'auto' : null"
                    *ngIf="dropdownAberto === p.nunota" (click)="$event.stopPropagation()">
                    <button class="dropdown-item item-editar" (click)="onEditar($event, p.nunota); fecharDropdown()">
                      <ng-container *ngIf="podeEditar(p)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                        Editar
                      </ng-container>
                      <ng-container *ngIf="!podeEditar(p)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                        </svg>
                        Visualizar
                      </ng-container>
                    </button>
                    <button class="dropdown-item item-editar-cabecalho"
                      [class.item-editar-cabecalho-desabilitado]="!podeEditarCabecalho(p)"
                      [title]="!podeEditarCabecalho(p) ? tituloEditarCabecalhoBloqueado(p) : 'Editar Dados da Venda'"
                      (click)="onEditarCabecalho($event, p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                      </svg>
                      Editar Dados da Venda
                    </button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item item-duplicar"
                      [class.item-duplicar-desabilitado]="!podeAcessarSeNaoCancelado(p)"
                      [title]="!podeAcessarSeNaoCancelado(p) ? tituloBloqueadoPorCancelado('Clonar Venda') : 'Clonar Venda'"
                      (click)="podeAcessarSeNaoCancelado(p) && onSolicitarDuplicar($event, p.nunota)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                      </svg>
                      Clonar Venda
                    </button>
                    <button class="dropdown-item item-dividir"
                      [class.item-dividir-desabilitado]="!p.podeDesm || !podeDesmembrarStatus(p)"
                      [title]="!podeDesmembrarStatus(p) ? tituloDesmembrarBloqueado(p) : (p.podeDesm === undefined ? 'Verificando itens...' : (p.podeDesm ? 'Desmembrar Venda' : 'Não é possível desmembrar: 1 item com quantidade 1'))"
                      (click)="p.podeDesm && podeDesmembrarStatus(p) && onSolicitarDividir($event, p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="21" y1="12" x2="3" y2="12"/>
                        <polyline points="9 18 3 12 9 6"/>
                        <polyline points="15 6 21 12 15 18"/>
                      </svg>
                      Desmembrar Venda
                    </button>
                    <button class="dropdown-item item-gerar-compra"
                      [class.item-gerar-compra-desabilitado]="!podeAcessarSeNaoCancelado(p)"
                      [title]="!podeAcessarSeNaoCancelado(p) ? tituloBloqueadoPorCancelado('Gerar Pedido de Compra') : 'Gerar Pedido de Compra'"
                      (click)="podeAcessarSeNaoCancelado(p) && onSolicitarGerarPedidoCompra($event, p.nunota)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                      </svg>
                      Gerar Pedido de Compra
                    </button>
                    <button class="dropdown-item item-transferir"
                      [class.item-transferir-desabilitado]="p.gplStatus !== 'ABERTO'"
                      [title]="p.gplStatus !== 'ABERTO' ? 'Só é possível transferir vendas com status Aberto' : 'Transferir Venda'"
                      (click)="p.gplStatus === 'ABERTO' && onSolicitarTransferir($event, p.nunota, p.codemp)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 12h14"/><path d="M12 5l7 7-7 7"/>
                      </svg>
                      Transferir Venda
                    </button>
                    <button class="dropdown-item item-transporte"
                      [class.item-transporte-desabilitado]="!podeAcessarSeNaoCancelado(p)"
                      [title]="!podeAcessarSeNaoCancelado(p) ? tituloBloqueadoPorCancelado('Dados do Transporte') : 'Dados do Transporte'"
                      (click)="podeAcessarSeNaoCancelado(p) && onSolicitarTransporte($event, p.nunota)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="1" y="3" width="15" height="13" rx="1"/>
                        <path d="M16 8h4l3 5v3h-7V8z"/>
                        <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
                      </svg>
                      Dados do Transporte
                    </button>
                    <button class="dropdown-item item-anexos"
                      [class.item-anexos-desabilitado]="!podeAcessarSeNaoCancelado(p)"
                      [title]="!podeAcessarSeNaoCancelado(p) ? tituloBloqueadoPorCancelado('Anexos') : 'Anexos'"
                      (click)="podeAcessarSeNaoCancelado(p) && onSolicitarAnexos($event, p.nunota)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
                      </svg>
                      Anexos
                    </button>
                    <button class="dropdown-item item-fluxo"
                      [class.item-fluxo-desabilitado]="p.temFluxo === false"
                      [title]="p.temFluxo === false ? 'Esta venda não possui fluxo de desmembramento' : 'Ver Fluxo de Desmembramento'"
                      (click)="p.temFluxo !== false && onSolicitarFluxo($event, p.nunota)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/>
                        <path d="M6 9v6"/><path d="M9 6h7a2 2 0 0 1 2 2v7"/>
                      </svg>
                      Ver Fluxo
                    </button>
                    <!-- Status ▸ submenu (mouseenter/leave para abrir) -->
                    <div class="status-wrapper"
                         (mouseenter)="statusSubMenuAberto = p.nunota"
                         (mouseleave)="statusSubMenuAberto = null">
                      <div class="dropdown-item item-status">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"/>
                          <polyline points="12 8 16 12 12 16"/>
                          <line x1="8" y1="12" x2="16" y2="12"/>
                        </svg>
                        Status
                        <svg class="item-status-arrow" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="9 18 15 12 9 6"/>
                        </svg>
                      </div>
                      <div class="submenu-status" *ngIf="statusSubMenuAberto === p.nunota">
                        <button class="dropdown-item item-autorizar"
                          [class.item-autorizar-desabilitado]="!podeAutorizar(p)"
                          [title]="podeAutorizar(p) ? 'Autorizar pedido' : ('Bloqueado: ' + tituloAutorizarBloqueado(p))"
                          (click)="onSolicitarAutorizar($event, p)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          Autorizar
                        </button>
                        <button class="dropdown-item item-cancelar-gpl"
                          [class.item-cancelar-gpl-desabilitado]="!podeCancelarGpl(p)"
                          [title]="podeCancelarGpl(p) ? 'Cancelar (marca o pedido como Cancelado, sem mexer na nota do Sankhya)' : (!ehOrcamento(p) ? 'Só é possível cancelar enquanto o pedido é Orçamento (TOP 1000)' : 'Só é possível cancelar pedidos com status Aberto')"
                          (click)="onClickCancelarGpl($event, p)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
                          </svg>
                          Cancelar
                        </button>
                        <button class="dropdown-item item-estornar"
                          [class.item-estornar-desabilitado]="!podeEstornarGpl(p)"
                          [title]="tituloEstornarGpl(p)"
                          (click)="onClickEstornarGpl($event, p)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="1 4 1 10 7 10"/>
                            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
                          </svg>
                          Estornar
                        </button>
                        <button class="dropdown-item item-finalizar-gpl"
                          [class.item-finalizar-gpl-desabilitado]="!podeFinalizarGpl(p)"
                          [title]="podeFinalizarGpl(p) ? 'Finalizar Venda — abre os Dados da Venda; ao salvar, muda o status para Finalizado' : 'Só é possível finalizar pedidos com status Pronto'"
                          (click)="onSolicitarFinalizarVenda($event, p)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <polyline points="22 4 12 14.01 9 11.01"/>
                          </svg>
                          Finalizar Venda
                        </button>
                      </div>
                    </div>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item item-cancelar"
                      [class.item-cancelar-desabilitado]="p.status === 'Atendido' || p.status === 'Atendimento'"
                      [title]="p.status === 'Atendido' ? 'Pedido Atendido — requer nota de devolução para estornar' : (p.status === 'Atendimento' ? 'Pedido em Atendimento — não é possível excluir' : 'Excluir pedido (cancelamento nativo Sankhya)')"
                      (click)="onClickExcluir($event, p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                        <path d="M10 11v6"/><path d="M14 11v6"/>
                        <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>
                      </svg>
                      Excluir
                    </button>
                  </div>
                </div>
              </td>
            </tr>

            <!-- Expandable Fluxo Row — oculto quando o filtro de fluxo está ativo -->
            <tr *ngIf="fluxoSelecionado === p.nunota && !filtroFluxoNunotas" class="linha-fluxo-expansao">
              <td colspan="13" class="td-fluxo">
                <div class="fluxo-container-inline">
                  
                  <div class="fluxo-header">
                    <div class="fluxo-icone">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/>
                        <path d="M6 9v6"/><path d="M9 6h7a2 2 0 0 1 2 2v7"/>
                      </svg>
                    </div>
                    <div>
                      <div class="fluxo-titulo">Fluxo de Desmembramento da Venda</div>
                      <div class="fluxo-subtitulo">Cadeia de desmembramentos da venda <strong>#{{ p.nunota }}</strong></div>
                    </div>
                    <button class="btn-filtrar-fluxo-inline" type="button"
                      (click)="filtrarVendasDoFluxoInline()"
                      title="Filtrar a lista para mostrar apenas os pedidos deste fluxo">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                      </svg>
                      Filtrar vendas do fluxo
                    </button>
                  </div>

                  <!-- Cadeia Hierárquica -->
                  <div class="fluxo-cadeia-wrap" style="margin-top: 16px;">
                    
                    <ng-template #fluxoNodeTemplate let-no="no">
                      <div class="flx-wrap">
                        
                        <!-- Esquerda (Pai) -->
                        <div class="flx-left">
                          <div class="fluxo-no"
                               [class.fluxo-no--selecionado]="no.ehSelecionada"
                               [class.fluxo-no--raiz]="no.ehRaiz && !no.ehSelecionada"
                               [class.fluxo-no--clicavel]="!no.ehSelecionada"
                               (click)="!no.ehSelecionada && navegarFluxoInline(no.nunota, no.codemp)">
                            <!-- Badge -->
                            <div class="fluxo-no-header">
                              <span *ngIf="no.ehRaiz" class="fluxo-badge fluxo-badge-raiz">Origem</span>
                              <span *ngIf="no.ehSelecionada" class="fluxo-badge fluxo-badge-sel">Esta venda</span>
                              <span *ngIf="!no.ehRaiz && !no.ehSelecionada" class="fluxo-badge fluxo-badge-nav">Abrir</span>
                            </div>
                            <!-- Infos -->
                            <div class="fluxo-no-num">#{{ no.nunota }}</div>
                            <div class="fluxo-no-data">{{ no.dtmov || '—' }}</div>
                            <span class="fluxo-no-status" [class]="fluxoStatusClass(no.status)">
                              {{ fluxoStatusLabel(no.status) }}
                            </span>
                            <!-- Chip empresa -->
                            <span *ngIf="no.codemp"
                                  class="fluxo-badge-emp"
                                  [style.background]="empresaState.corClaraPorCodEmp(no.codemp)"
                                  [style.border-color]="empresaState.corPorCodEmp(no.codemp)">
                              Filial {{ no.codemp }}
                            </span>
                          </div>
                        </div>

                        <!-- Direita (Filhos) -->
                        <div class="flx-right" *ngIf="no.filhos?.length > 0">
                          <div class="flx-row" *ngFor="let filho of no.filhos; let i = index; let first = first; let last = last"
                               [class.is-first]="first" [class.is-last]="last">
                            
                            <!-- Conector Horizontal -->
                            <div class="flx-hz" [class.is-primary]="first" [class.is-secondary]="!first"></div>
                            
                            <!-- Filho -->
                            <ng-container *ngTemplateOutlet="fluxoNodeTemplate; context: { no: filho }"></ng-container>
                          </div>
                        </div>

                      </div>
                    </ng-template>

                    <div class="flx-root">
                      <ng-container *ngFor="let raiz of fluxoRaizes">
                        <ng-container *ngTemplateOutlet="fluxoNodeTemplate; context: { no: raiz }"></ng-container>
                      </ng-container>
                    </div>

                  </div>
                  
                </div>
              </td>
            </tr>
            </ng-container>
          </tbody>
        </table>

        <!-- ── RODAPÉ: total + por página + paginação ── -->
        <div class="tabela-rodape">
          <span class="rodape-total">
            {{ pedidos.length }} pedido{{ pedidos.length !== 1 ? 's' : '' }}
          </span>

          <div class="rodape-paginacao">
            <div class="por-pagina">
              <span>Exibir</span>
              <select [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()" class="sel-pagina">
                <option *ngFor="let n of opcoesPorPagina" [value]="n">{{ n }}</option>
              </select>
              <span>por página</span>
            </div>

            <div class="pag-controles">
              <button class="pag-btn" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1" title="Primeira">«</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual - 1)" [disabled]="paginaAtual === 1" title="Anterior">‹</button>

              <button *ngIf="paginas[0] > 1" class="pag-btn pag-ellipsis" disabled>…</button>
              <button *ngFor="let p of paginas" class="pag-btn"
                [class.pag-ativo]="p === paginaAtual"
                (click)="irParaPagina(p)">{{ p }}</button>
              <button *ngIf="paginas[paginas.length - 1] < totalPaginas" class="pag-btn pag-ellipsis" disabled>…</button>

              <button class="pag-btn" (click)="irParaPagina(paginaAtual + 1)" [disabled]="paginaAtual === totalPaginas" title="Próxima">›</button>
              <button class="pag-btn" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas" title="Última">»</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </div>
</div>

<!-- ── MODAL CONFIRMAÇÃO CANCELAMENTO ── -->
<div class="modal-overlay" *ngIf="confirmandoCancelamento !== null" (click)="cancelarConfirmacao()">
  <div class="modal-confirm" (click)="$event.stopPropagation()">
    <div class="modal-confirm-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    </div>
    <div class="modal-confirm-titulo">Confirmar exclusão</div>
    <div class="modal-confirm-msg">
      Tem certeza que deseja excluir o pedido <strong>#{{ confirmandoCancelamento }}</strong>?
      Esta ação não pode ser desfeita.
    </div>
    <div class="modal-confirm-motivo">
      <label class="motivo-label">Motivo da exclusão <span class="motivo-opcional">(opcional)</span></label>

      <!-- Dropdown com motivos pré-cadastrados -->
      <div *ngIf="!carregandoMotivos && motivosDisponiveis.length > 0">
        <select class="motivo-select" [(ngModel)]="motivoCancelamento">
          <option value="">Selecione um motivo...</option>
          <option *ngFor="let m of motivosDisponiveis" [value]="m">{{ m }}</option>
        </select>
      </div>

      <!-- Carregando -->
      <div *ngIf="carregandoMotivos" class="motivo-carregando">
        <app-loading-indicator size="inline"></app-loading-indicator>
        <span>Carregando motivos...</span>
      </div>

      <!-- Fallback: nenhum motivo cadastrado -->
      <div *ngIf="!carregandoMotivos && motivosDisponiveis.length === 0">
        <input type="text" class="motivo-input"
          [(ngModel)]="motivoCancelamento"
          placeholder="Informe o motivo..."
          maxlength="300">
      </div>
    </div>
    <div class="modal-confirm-acoes">
      <button type="button" class="btn-confirm-nao" (click)="cancelarConfirmacao()">Não, voltar</button>
      <button type="button" class="btn-confirm-sim" (click)="confirmarCancelamento()">Sim, excluir</button>
    </div>
  </div>
</div>

<!-- ── MODAL EDITAR DADOS DA VENDA (cliente, endereço, aeronave, tipo
     negociação e observações — sem tocar Itens/Comissionado) ── -->
<div class="modal-overlay" *ngIf="mostrarModalCabecalho">
  <div class="modal-cabecalho-venda" (click)="$event.stopPropagation()">
    <app-pedido-venda
      [nunotaEditar]="nunotaParaEditarCabecalho"
      [somenteCabecalho]="true"
      [forcarFinalizarAoSalvar]="finalizandoVenda"
      (voltarLista)="fecharModalCabecalho()">
    </app-pedido-venda>
  </div>
</div>

<!-- ── MODAL DETALHE ── -->
<div class="modal-overlay" *ngIf="detalheAberto" (click)="fecharDetalhe()">
  <div class="modal-detalhe" (click)="$event.stopPropagation()">

    <div class="modal-header-det">
      <div>
        <div class="modal-titulo">Pedido #{{ detalhe?.nunota ?? '...' }}</div>
        <div class="modal-subtitulo">{{ detalhe?.cliente ?? '' }}</div>
      </div>
      <button type="button" class="modal-fechar" (click)="fecharDetalhe()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="modal-body-det">
      <div *ngIf="detalheCarregando" class="loading-row">
        <app-loading-indicator></app-loading-indicator>
        <span>Carregando detalhes...</span>
      </div>

      <ng-container *ngIf="!detalheCarregando && detalhe">
        <div class="det-grid">
          <div class="det-campo">
            <label>Data</label><span>{{ detalhe.dtmov }}</span>
          </div>
          <div class="det-campo">
            <label>Status</label>
            <span class="status-badge" [ngClass]="statusClass(detalhe.status)">{{ detalhe.status }}</span>
          </div>
          <div class="det-campo">
            <label>Empresa</label><span>{{ empresaLabel(detalhe) }}</span>
          </div>
          <div class="det-campo">
            <label>Vendedor</label><span>{{ detalhe.vendedor }}</span>
          </div>
          <div class="det-campo">
            <label>Tipo de Operação</label><span>{{ detalhe.tipoOperacao }}</span>
          </div>
          <div class="det-campo" *ngIf="detalhe.cifFob">
            <label>CIF/FOB</label><span>{{ detalhe.cifFob }}</span>
          </div>
          <div class="det-campo" *ngIf="detalhe.formaEnvio">
            <label>Forma de Envio</label><span>{{ detalhe.formaEnvio }}</span>
          </div>
          <div class="det-campo" *ngIf="detalhe.vlrFrete > 0">
            <label>Frete</label><span>{{ fmtMoeda(detalhe.vlrFrete) }}</span>
          </div>
          <div class="det-campo" *ngIf="detalhe.observacao">
            <label>Observação</label><span>{{ detalhe.observacao }}</span>
          </div>
        </div>

        <div class="det-secao-titulo">Itens do Pedido</div>
        <table class="tabela-itens">
          <thead>
            <tr>
              <th>#</th>
              <th>Produto</th>
              <th class="col-right">Qtd</th>
              <th class="col-right">Vl. Unit.</th>
              <th class="col-right">Desc.%</th>
              <th class="col-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let it of detalhe.itens">
              <td class="col-seq">{{ it.seq }}</td>
              <td>
                <div class="item-desc">{{ it.descricao }}</div>
                <div class="item-codvol">Cód: {{ it.codprod }} | UN: {{ it.codvol }}</div>
              </td>
              <td class="col-right">{{ fmtQtd(it.qtd) }}</td>
              <td class="col-right">{{ fmtMoeda(it.vlrunit) }}</td>
              <td class="col-right">{{ it.percdesc | number:'1.2-2' }}%</td>
              <td class="col-right"><strong>{{ fmtMoeda(itemTotalLiquido(it)) }}</strong></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5" class="col-right total-label">Total do Pedido</td>
              <td class="col-right total-valor">{{ fmtMoeda(detalhe.vlrnota) }}</td>
            </tr>
          </tfoot>
        </table>
      </ng-container>
    </div>
  </div>


</div>
